import { useState, type FormEvent } from "react";
import { useAuth } from "./AuthContext";
import { Button, TextField, Wordmark } from "@/components/ui";
import "./login.css";

export function LoginPage() {
  const { login, loading, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    void login(email.trim(), password);
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={onSubmit}>
        <div className="login__brand">
          <Wordmark subtitle="Staff console" />
        </div>
        <h1 className="login__title">Sign in</h1>
        <p className="login__lede">Staff access only. Use your Arkitectly staff account.</p>

        {error ? <p className="login__error" role="alert">{error}</p> : null}

        <TextField
          label="Email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={loading}>
          Sign in
        </Button>
      </form>
    </div>
  );
}
